"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function LineIcon({
  className
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="currentColor">
      <path d="M23.375 10.438c0-4.882-4.832-8.86-10.771-8.86C6.666 1.578 1.832 5.556 1.832 10.438c0 4.376 3.834 8.04 9.015 8.718.351.075.829.23.95.526.108.263.071.674.035.94l-.15 1.011c-.046.27-.214 1.057.923.577 1.137-.48 6.136-3.614 8.373-6.19 1.637-1.84 2.397-3.7 2.397-5.582zm-14.856 2.51H7.135a.434.434 0 01-.435-.434V8.31a.434.434 0 01.435-.435h1.384a.435.435 0 01.435.435v.421a.435.435 0 01-.435.435H7.57v.933h.95a.435.435 0 01.434.435v.42c0 .24-.195.435-.435.435zm3.018 0h-1.39a.434.434 0 01-.434-.434V8.31a.434.434 0 01.434-.435h.423a.435.435 0 01.435.435v.421a.435.435 0 01-.435.435h-.033zm2.557-.434a.435.435 0 01-.435.434h-.431a.435.435 0 01-.435-.434V9.6l-1.127 2.914a.428.428 0 01-.403.274h-.35a.426.426 0 01-.4-.274L10.237 9.6v2.914a.435.435 0 01-.435.434h-.431a.435.435 0 01-.435-.434V8.31a.435.435 0 01.435-.435h.624c.182 0 .343.113.404.285l1.246 3.226 1.246-3.226a.426.426 0 01.404-.285h.624a.435.435 0 01.435.435v.421zm3.931-2.221h-.95v-.425h.95a.435.435 0 01.435.435v.42a.435.435 0 01-.435.435h-.95v.934h1.383a.435.435 0 01.435.434v.421a.434.434 0 01-.435.434h-2.241a.434.434 0 01-.434-.434V8.31a.434.434 0 01.434-.435h2.241a.435.435 0 01.435.435v.42a.435.435 0 01-.435.435z" />
    </svg>;
}
function InstagramIcon({
  className
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
    </svg>;
}
function FacebookIcon({
  className
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="currentColor">
      <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c4.56-.93 8-4.96 8-9.8z" />
    </svg>;
}
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-4">
        {[1, 2, 3, 4, 5].map((_, i) => <li key={i} className="h-5 w-24 bg-white/10 animate-pulse rounded" />)}
      </ul>;
  }
  const filteredItems = menuItems.filter(item => {
    const href = item.href || "";
    const label = item.label || "";
    return !href.includes("wvc_removed_post") && !/shop|商店/i.test(label);
  });
  return <ul className="space-y-4 text-sm font-hk-light tracking-widest text-white/90">
      {filteredItems.map(item => {
      const cnText = item.label.split("/")[0]?.trim() || item.label;
      return <li key={item.id}>
            <Link to={item.href || "#"} className="hover:text-white transition-colors duration-300 block">
              {cnText}
            </Link>
          </li>;
    })}
    </ul>;
}
export default function Footer() {
  return <section id="頁尾資訊-footer" className="w-full bg-[#5a4b41] text-white">
  <div className="max-w-7xl mx-auto pt-20 pb-16 px-6 md:px-12 lg:px-20">
    
    {/* 網格容器 */}
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 items-start">
      
      {/*  第 1 欄：台南品牌門市 (基準高度 h-9) */}
      <div className="space-y-6">
        {/* 這裡的 Logo 容器高度為 h-9 */}
        <div className="flex h-9 items-center gap-3.5 select-none">
          <Link to="/" className="inline-block shrink-0">
            <img src="https://hent.services/wp-content/uploads/2026/05/Logo-W.png" alt="Hent's Flooring" className="h-9 w-auto object-contain brightness-0 invert" />
          </Link>
          <div className="w-[1px] h-5 bg-white/20 shrink-0" />
          <h3 className="text-sm font-hk-regular tracking-widest text-white pt-0.5 whitespace-nowrap">
            台南品牌門市
          </h3>
        </div>

        {/* 聯絡資訊 */}
        <div className="space-y-2.5 text-sm font-hk-light tracking-widest text-white/90">
          <p>06-2984755</p>
          <p>06-2950733</p>
          <p className="font-sans text-xs opacity-90">hents.flooring@gmail.com</p>
          <p className="text-xs md:text-sm">台南市安平區府平路472號</p>
        </div>
      </div>

      {/*  第 2 欄：關於亨特 (同步鎖定 h-9 垂直居中) */}
      <div className="space-y-6">
        {/* 核心修改：加上 flex h-9 items-center，強迫與第 1 欄 Logo 區絕對水平切齊 */}
        <div className="flex h-9 items-center lg:pl-4">
          <h3 className="text-sm font-hk-regular tracking-widest text-white">
            關於亨特
          </h3>
        </div>
        <div className="lg:pl-4">
          <MenuProvider menu_id="59">
            <FooterMenuConsumer />
          </MenuProvider>
        </div>
      </div>

      {/*  第 3 欄：全台各地區經銷點 (同步鎖定 h-9 垂直居中) */}
      <div className="space-y-6">
        {/* 核心修改：加上 flex h-9 items-center，強迫起跑線水平切齊 */}
        <div className="flex h-9 items-center">
          <h3 className="text-sm font-hk-regular tracking-widest text-white">
            全台各地區經銷
          </h3>
        </div>
        <div className="space-y-5 text-sm font-hk-light tracking-widest text-white/90 leading-relaxed">
          <div className="space-y-0.5">
            <p className="font-hk-regular text-white text-sm">千輝經銷點</p>
            <p className="text-xs text-white/80">高雄市三民區中華二路339號</p>
            <p className="text-[11px] font-sans text-white/60 tracking-wider">T：07-5521675 / F：07-5521192</p>
          </div>
          <div className="space-y-0.5">
            <p className="font-hk-regular text-white text-sm">琦暐經銷點</p>
            <p className="text-xs text-white/80">高雄市鳳山區頂庄路191號</p>
            <p className="text-[11px] font-sans text-white/60 tracking-wider">T：07-7920191 / F：07-7934868</p>
          </div>
          <div className="space-y-0.5">
            <p className="font-hk-regular text-white text-sm">台中經銷點</p>
            <p className="text-xs text-white/80">台中市北屯區太原路三段850號</p>
            <p className="text-[11px] font-sans text-white/60 tracking-wider">T：04-24351077 / 0976-807910</p>
          </div>
        </div>
      </div>

      {/*  第 4 欄：社群追蹤 (同步鎖定 h-9 垂直居中) */}
     <div className="space-y-6">
        {/* 核心修改：加上 flex h-9 items-center，強迫起跑線水平切齊 */}
        <div className="flex h-9 items-center">
          <h3 className="text-sm font-hk-regular tracking-widest text-white uppercase">
            Follow Us
          </h3>
        </div>
        
        <div className="flex items-center gap-5 text-white/90">
          
          {/* 🟢 1. 點擊加 LINE 好友 */}
          {/* 提示：把下面的 @your_line_id 換成你們官方帳號的 LINE ID（記得保留 @） */}
          <Link to="https://line.me/R/ti/p/@floor_pro" target="_blank" rel="noopener noreferrer" className="hover:text-[#06C755] transition-colors duration-300">
            <LineIcon className="size-6" />
            <span className="sr-only">LINE</span>
          </Link>
          
          {/*  2. 點擊開 IG 專頁 */}
          {/* 提示：把 your_instagram_id 換成你們的 IG 帳號名稱 */}
          <Link to="https://www.instagram.com/hents.flooring/" target="_blank" rel="noopener noreferrer" className="hover:text-[#E1306C] transition-colors duration-300">
            <InstagramIcon className="size-6" />
            <span className="sr-only">Instagram</span>
          </Link>
          
          {/*  3. 點擊開臉書粉專 */}
          {/* 提示：把 your_facebook_page 換成你們臉書粉專的網址後綴或 ID */}
          <Link to="https://www.facebook.com/HentsFlooring" target="_blank" rel="noopener noreferrer" className="hover:text-[#1877F2] transition-colors duration-300">
            <FacebookIcon className="size-5" />
            <span className="sr-only">Facebook</span>
          </Link>

        </div>
      </div>

    </div>

  </div>
</section>;
}